import { Backlink, Contentheader, Pagesection } from '@ktag/styleguide/dist/react';
import WAPBreadcrumbs from 'lib/WAPBreadcrumbs/WAPBreadcrumbs';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  type: 'poll' | 'pollday';
}

const NotFoundMessage = ({ type }: Props) => {
  const { t } = useTranslation('wap');

  return (
    <Pagesection>
      <Contentheader
        beforeBreadcrumbs={<WAPBreadcrumbs />}
        pagetitle={t('not_found_title')}
        leadtext={
          type === 'poll' ? t('not_found_lead_poll') : t('not_found_lead_pollday')
        }
        beforeBacklink={<Backlink text={t('not_found_back')} url="#" />}
      />
    </Pagesection>
  );
};

export default NotFoundMessage;
